export const steps = ["Personal Information", "Education Background", "Declaration"];

export const stepsForComponent = ["", "", ""];

export const genderOptions = [
  { label: "Male", value: 1 },
  { label: "Female", value: 2 },
];

export const computerPrograms = [
  { name: "MS Office", id: 1 },
  { name: "SAP/ERP", id: 2 },
  { name: "Other (specify)", id: 3 },
];
export const programsList = [
  { label: "MS Office", value: 1 },
  { label: "SAP/ERP", value: 2 },
  { label: "Other (specify)", value: 3 },
];
export const programNameToId = {
  "MS Office": 1,
  "SAP/ERP": 2,
  "Other (specify)": 3,
};

export const extraQuestionOptions = [
  { label: "Yes", value: 1 },
  { label: "No", value: 2 },
];

export const extraQuestionOptions2 = [
  { label: "From a friend", value: 1 },
  { label: "From a person who already works in TIA", value: 2 },
  { label: "From the advertisement in newspaper", value: 3 },
  { label: " From Internet", value: 4 },
];

export const languageLevels = [
  { label: "Basic", value: "Basic" },
  { label: "Intermediate", value: "Intermediate" },
  { label: "Fluent", value: "Fluent" },
  { label: "Native", value: "Native" },
];

export const workTimeOptions = [
  { label: "Full-Time", value: 1 },
  { label: "Seasonal", value: 2 },
  { label: "Internship", value: 3 },
];

export const availabilityMap = {
  1: "Full-Time",
  2: "Seasonal",
  3: "Internship",
};

export const apiEndpoint =
  "https://w9jvyw0xk9.execute-api.eu-central-1.amazonaws.com/prod";


// Dev
// export const apiEndpoint = "https://4l6iouhmoa.execute-api.eu-central-1.amazonaws.com/prod";
